import { Image } from '../../state/images';

export const EMPTY_IMAGE: Image = Object.freeze({
  id: '',
  url: null,
});
